import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, Button, FormFeedback } from 'reactstrap';
import InputMask from 'react-input-mask';
import './AuthorizedUser.scss';
import DatePicker from '../DatePicker/DatePicker';
import AddressFields from '../Address/AddressFields';
import { format } from 'date-fns';

class AuthorizedUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phoneDropdownOpen: false,
      firstName: (this.props.authUser && this.props.authUser.firstName) || "",
      lastName: (this.props.authUser && this.props.authUser.lastName) || "",
      birthdate: (this.props.authUser && this.props.authUser.birthdate) || "",
      address1: (this.props.authUser && this.props.authUser.address1) || "",
      address2: (this.props.authUser && this.props.authUser.address2) || "",
      city: (this.props.authUser && this.props.authUser.city) || "",
      province: (this.props.authUser && this.props.authUser.province) || "",
      postalCode: (this.props.authUser && this.props.authUser.postalCode) || "",
      //PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
      mobilePhone: (this.props.authUser && this.props.authUser.mobilePhone) || "",
      homePhone:  (this.props.authUser && this.props.authUser.homePhone) || "",
      //PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
      email: (this.props.authUser && this.props.authUser.email) || "", 
      sameAsMyAddress: (this.props.authUser && this.props.authUser.sameAsMyAddress) || false,
      manualEntry: (this.props.authUser && this.props.authUser.manualEntry) || false,
    };    

    this.handleChange = this.handleChange.bind(this);
    this.removeAuthUser = this.removeAuthUser.bind(this);
    this.populateAddressFields = this.populateAddressFields.bind(this);
    this.updateAuthUser = this.updateAuthUser.bind(this);
    this.validateField = this.validateField.bind(this);
    this.setManualEntry = this.setManualEntry.bind(this);
    this.resetAddressFieldValidation = this.resetAddressFieldValidation.bind(this);
    this.toggleSameAsMyAddress = this.toggleSameAsMyAddress.bind(this);
    this.resetSameAsMyAddress = this.resetSameAsMyAddress.bind(this);
  }
  componentDidUpdate(prevProps) {
    if(prevProps.authUser !== this.props.authUser) {      
      this.setState({
        firstName: this.props.authUser.firstName,
        lastName: this.props.authUser.lastName,
        birthdate: this.props.authUser.birthdate,
        address1: this.props.authUser.address1,
        address2: this.props.authUser.address2,
        city: this.props.authUser.city,
        province: this.props.authUser.province,
        postalCode: this.props.authUser.postalCode,
        //PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
        mobilePhone: this.props.authUser.mobilePhone,
        homePhone: this.props.authUser.homePhone,
        //PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
        email: this.props.authUser.email,
        manualEntry: this.props.authUser.manualEntry,
        sameAsMyAddress: this.props.authUser.sameAsMyAddress,
      });
    }
  }
  
  updateAuthUser() {
    this.props.updateAuthUser({
      id: this.props.authUser.id,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      birthdate: this.state.birthdate,
      address1: this.state.address1,
      address2: this.state.address2,
      city: this.state.city,
      province: this.state.province,
      postalCode: this.state.postalCode,
      //PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
      mobilePhone: this.state.mobilePhone,
      homePhone: this.state.homePhone,
      email: this.state.email,
      manualEntry: this.state.manualEntry,
      sameAsMyAddress: this.state.sameAsMyAddress,
    }, this.props.index);
  }
  handleChange(event) {
    if(event.target.name === "birthdate") {
      this.props.validateField(event, this.props.index);
      this.setState({
        [event.target.name]: format(new Date(event.target.value), "yyyy-MM-dd")
      }, () => {
        this.updateAuthUser();
      });
    }
    else {
      this.props.resetFieldValidation(event, this.props.index);
      this.setState({
        [event.target.name]: event.target.value
      }, () => {
        this.updateAuthUser();
      });
    }
    
  }

  removeAuthUser() {
    this.props.removeAuthUser(this.props.index);
  }
  populateAddressFields(addressFields) {
    this.setState({...addressFields}, () => {
      this.updateAuthUser();
      this.resetAddressFieldValidation();
    });
  }
  validateField(event) {
    this.props.validateField(event, this.props.index);
  }

  setManualEntry(value) {
    // Change manualEntry and reset validation
    this.setState({
      manualEntry: value
    }, () => {
      this.updateAuthUser();
      this.resetAddressFieldValidation();
    });
  }
  resetAddressFieldValidation() {
    this.props.resetAddressFieldValidation(this.props.index);
  }

  resetSameAsMyAddress() {
    this.setState({sameAsMyAddress: false});
  }
  toggleSameAsMyAddress(value) {
    if(value) {
      this.setState({
        address1: this.props.address.address1,
        address2: this.props.address.address2,
        city: this.props.address.city,
        province: this.props.address.province,
        postalCode: this.props.address.postalCode,
        sameAsMyAddress: true,
        manualEntry: true
      }, () => {
        this.updateAuthUser();
        this.resetAddressFieldValidation();
      });
    }
    else {
      this.setState({
        address1: "",
        address2: "",
        city: "",
        province: "BC",
        postalCode: "",
        sameAsMyAddress: false,
        manualEntry: false
      }, () => {
        this.updateAuthUser();
        this.resetAddressFieldValidation();
      });
    }
  }
  render() {
    let autocompleteValidation = {
      homeAddress: {
        isInvalid: false,
        message: ""
      }
    };
    if(this.props.validation.homeAddress !== undefined) {
      autocompleteValidation = {homeAddress: this.props.validation.homeAddress};
    }

    return (
      <div className="authorized-user-container" name="element">
        <div className="user-num-container">
          Authorized user {this.props.index + 1}
        </div>
        <FormGroup id={this.props.validation.firstName.isInvalid ? `auth-user-${this.props.index}-invalid` : ""}>
          <Label for="firstName">First Name</Label>
          <Input name="firstName" value={this.state.firstName} onBlur={this.validateField} onChange={this.handleChange} id="firstName" invalid={this.props.validation.firstName.isInvalid} maxLength="25" autoFocus={this.props.autoFocus} />
          <FormFeedback>{this.props.validation.firstName.message}</FormFeedback>
        </FormGroup>
        <FormGroup id={this.props.validation.lastName.isInvalid ? `auth-user-${this.props.index}-invalid` : ""}>
          <Label for="lastName">Last Name</Label>
          <Input name="lastName" value={this.state.lastName} onBlur={this.validateField} onChange={this.handleChange} id="lastName" invalid={this.props.validation.lastName.isInvalid} maxLength="35" />
          <FormFeedback>{this.props.validation.lastName.message}</FormFeedback>
        </FormGroup>                    
        <FormGroup id={this.props.validation.birthdate.isInvalid ? `auth-user-${this.props.index}-invalid` : ""}>
          <Label for="birthdate">Birthdate</Label>
          <DatePicker name="birthdate" value={this.state.birthdate} onChange={this.handleChange} error={this.props.validation.birthdate.isInvalid} errorMessage={this.props.validation.birthdate.message}  />  
        </FormGroup>
        {/* PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form */}
        <FormGroup id={this.props.validation.email.isInvalid ? `auth-user-${this.props.index}-invalid` : ""}>
          <Label for="email">Email</Label>
          <Input type="email" value={this.state.email} onBlur={this.validateField} onChange={this.handleChange}  name="email" id="email" invalid={this.props.validation.email.isInvalid} autoFocus={this.props.autoFocus} maxLength="50" autoComplete="email" autoCapitalize="off" autoCorrect="off" />
          <FormFeedback>{this.props.validation.email.message}</FormFeedback>
        </FormGroup>
        {/* PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers    */}
        <FormGroup id={this.props.validation.mobilePhone.isInvalid ? `auth-user-${this.props.index}-invalid` : ""}>
          <Label for="mobilePhone">Mobile Phone</Label>
          <InputMask mask="999-999-9999" value={this.state.mobilePhone} onBlur={this.validateField} onChange={this.handleChange} onKeyDown={this.props.onKeyDown} onSelect={this.props.onClick} onClick={this.props.onClick} beforeMaskedValueChange={this.props.beforeMaskedValueChange} autoFocus={this.props.autoFocus}>
            {(inputProps) => <Input name="mobilePhone" {...inputProps} id="phone" type="tel" invalid={this.props.validation.mobilePhone.isInvalid} autoComplete="tel-national" autoCapitalize="off" autoCorrect="off" />}
          </InputMask>
          <FormFeedback>{this.props.validation.mobilePhone.message}</FormFeedback>        
        </FormGroup>
        <FormGroup id={this.props.validation.homePhone.isInvalid ? `auth-user-${this.props.index}-invalid` : ""}>
          <Label for="homePhone">Home Phone</Label>
          <InputMask mask="999-999-9999" value={this.state.homePhone} onBlur={this.validateField} onChange={this.handleChange} onKeyDown={this.props.onKeyDown} onSelect={this.props.onClick} onClick={this.props.onClick} beforeMaskedValueChange={this.props.beforeMaskedValueChange} autoFocus={this.props.autoFocus}>
            {(inputProps) => <Input name="homePhone" {...inputProps} id="phone" type="tel" invalid={this.props.validation.homePhone.isInvalid} autoComplete="tel-national" autoCapitalize="off" autoCorrect="off" />}
          </InputMask>
          <FormFeedback>{this.props.validation.homePhone.message}</FormFeedback>        
        </FormGroup>
        <AddressFields 
          handleChange={this.handleChange} 
          validateField={this.validateField} 
          populateAddressFields={this.populateAddressFields} 
          validation={this.props.validation} 
          autocompleteValidation={autocompleteValidation} 
          {...this.state} 
          setManualEntry={this.setManualEntry} 
          toggleSameAsMyAddress={this.toggleSameAsMyAddress} 
          resetSameAsMyAddress={this.resetSameAsMyAddress}
          authUserIndex={this.props.index} />          
        <Button onClick={this.removeAuthUser} className="remove">{this.props.removeText}</Button>
      </div>);
  }
}

AuthorizedUser.defaultProps= {  
  authUser: { id: 0 },
  saveAuthUser: () => {},
  removeAuthUser: () => {},
  validateField: () => {},
  resetFieldValidation: () => {},  
  updateAuthUser: () => {},
  resetAddressFieldValidation: () => {},
  removeText: "Remove",
  index: 0,
  validation: {
    firstName: {
      isInvalid: false,
      message: ""
    },
    lastName: {
      isInvalid: false,
      message: ""
    },
    birthdate: {
      isInvalid: false,
      message: ""
    },
    //PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
    email: {
      isInvalid: false,
      message: ""
    },
    //PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
    mobilePhone: {
      isInvalid: false,
      message: ""
    },
    homePhone: {
      isInvalid: false,
      message: ""
    },
    address1: {
      isInvalid: false,
      message: ""
    },
    address2: {
      isInvalid: false,
      message: ""
    },
    city: {
      isInvalid: false,
      message: ""
    },
    province: {
      isInvalid: false,
      message: ""
    },
    postalCode: {
      isInvalid: false,
      message: ""
    }
  },
  address: {
    address1: "",
    address2: "",
    city: "",
    province: "",
    postalCode: ""
  },
  autoFocus: false
};

AuthorizedUser.propTypes = {
  authUser: PropTypes.object,
  saveAuthUser: PropTypes.func,
  removeAuthUser: PropTypes.func,
  validateField: PropTypes.func,
  resetFieldValidation: PropTypes.func,
  index: PropTypes.number,
  removeText: PropTypes.string,
  autoFocus: PropTypes.bool
};
export default AuthorizedUser;


// WEBPACK FOOTER //
// ./src/components/AuthorizedUser/AuthorizedUser.js